import React, { ReactNode, ReactNodeArray, useState } from 'react'
import { Helmet } from 'react-helmet'
import { Scrollable } from '../Scrollable'
import {
  GreyContainerTemplate,
  SidebarPrimaryTemplate,
  SilverContainerTemplate,
  SidebarSecondaryTemplate,
  ContentTemplate,
  ChildrenContainer,
  DragOverlay,
} from './styled'

export interface IMain {
  children?: ReactNode | ReactNodeArray | string
  sidebarPrimary?: ReactNode
  sidebarSecondary?: ReactNode
  titleBlock?: ReactNode
  header?: ReactNode
  scrollContent?: boolean
  helmet?: string
}

export const Main = ({
  sidebarPrimary,
  sidebarSecondary,
  titleBlock,
  scrollContent,
  header,
  helmet = 'Reuters Graphics',
  children,
}: IMain) => {
  const [isDragOver, setIsDragOver] = useState(false)
  return (
    <GreyContainerTemplate
      onDragOver={(e) => {
        setIsDragOver(true)
      }}
      onDrop={(e) => {
        e.preventDefault()
        setIsDragOver(false)
      }}
    >
      <Helmet>
        <title>{helmet}</title>
      </Helmet>
      {sidebarPrimary && (
        <SidebarPrimaryTemplate id="sidebar-primary">
          <Scrollable>{sidebarPrimary}</Scrollable>
        </SidebarPrimaryTemplate>
      )}
      <SilverContainerTemplate>
        {sidebarSecondary && (
          <SidebarSecondaryTemplate id="sidebar-secondary">
            <Scrollable>{sidebarSecondary}</Scrollable>
          </SidebarSecondaryTemplate>
        )}
        <ContentTemplate scrollContent={scrollContent}>
          {header && header}
          {titleBlock && <div className="title-block">{titleBlock}</div>}
          <ChildrenContainer>{children}</ChildrenContainer>
        </ContentTemplate>
      </SilverContainerTemplate>
      <DragOverlay
        show={isDragOver}
        onDragOver={(e) => {
          e.preventDefault()
        }}
        onDragLeave={(e) => {
          setIsDragOver(false)
        }}
        className="drag-overlay"
      />
    </GreyContainerTemplate>
  )
}
